import React, { useEffect, useState, useRef } from "react";
import { Tooltip, IconButton, Badge, Box } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import { connect, useDispatch } from "react-redux";
import { serverurl } from "../../../app/router/config";
import * as liveViewAction from "../../../infofleet/ducks/liveView";
import api from "../../../app/router/axiosConfig";
import KTOffcanvas from "../../_assets/js/offcanvas";
import notificationsound from "../../../assets/infofleet/livenotification.wav";

function NotificationPanelToggler({ liveView }) {

  const [notificationCount, setNotificationCount] = useState(0);
  const [notificationRead, setNotificationRead] = useState(0);

  // 🔕 Mute state from localStorage (FIXED)
  const [isMuted, setIsMuted] = useState(() =>
    JSON.parse(localStorage.getItem("notification_muted") || "false")
  );

  const dispatch = useDispatch();
  const offcanvasRef = useRef(null);
  const audioRef = useRef(null);
  const prevCountRef = useRef(0); // ✅ track previous count safely

  // Initialize audio once
  useEffect(() => {
    audioRef.current = new Audio(notificationsound);
    audioRef.current.volume = 0.6;
  }, []);

  // Fetch notification count + auto refresh (FIXED)
  useEffect(() => {
    let intervalId;

    const fetchCount = async () => {
      try {
        const res = await api.get(serverurl + "getRealTimeNotificationCount");

        // 🔊 Play only when new notification arrives
        if (res.data > prevCountRef.current) {
          playSound();
        }

        prevCountRef.current = res.data;
        setNotificationCount(res.data);

      } catch (err) {
        console.error("Error fetching notification count:", err);
      }
    };

    fetchCount();

    api.get(serverurl + "getLoggedUserAutoRefreshTime").then((res) => {
      const refreshData = res?.data;
      if (refreshData?.time > 0 && refreshData?.active === true) {
        intervalId = setInterval(fetchCount, refreshData.time * 1000);
      }
    });

    // ✅ Cleanup interval
    return () => {
      if (intervalId) clearInterval(intervalId);
    };

  }, []); // run once only

  // Play sound safely
  const playSound = () => {
    // 🔕 Respect mute option
    if (isMuted) return;
    if (!audioRef.current) return;

    audioRef.current.pause();
    audioRef.current.currentTime = 0;
    audioRef.current.play().catch(() => {
      // Autoplay blocked - will work after user interaction
    });
  };

  // Initialize offcanvas
  useEffect(() => {
    const panel = document.getElementById("kt_quick_panel");
    if (panel) {
      offcanvasRef.current = new KTOffcanvas(panel, {
        overlay: true,
        baseClass: "kt-quick-panel",
        closeBy: "kt_quick_panel_close_btn",
        toggleBy: "kt_quick_panel_toggler_btn",
      });
    }
  }, []);

  // Bell click handler
  const handleClick = () => {
    api.get(serverurl + "getRealTimeNotification").then((res) => {
      if (res.data.length > 0) {
        dispatch(liveViewAction.actions.notificationlist(res.data));
        api.get(serverurl + "setNotificationRead").then((res) => {
          setNotificationRead(res.data);
        });
        if (offcanvasRef.current) {
          offcanvasRef.current.show();
        }
      }
    });
  };

  // Toggle mute (FIXED)
  const toggleMute = () => {
    setIsMuted(prev => {
      const newState = !prev;
      localStorage.setItem("notification_muted", JSON.stringify(newState));
      return newState;
    });
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>

      {/* Notification Bell */}
      <Tooltip
        title={
          <Box fontSize={10}>
            <strong>Notifications:</strong> Fleet Alerts & Exceptions
          </Box>
        }
        arrow
      >
        <IconButton
          onClick={handleClick}
          id="kt_quick_panel_toggler_btn"
          sx={{ color: "#1e4b8c", p: 0 }}
        >
          <Badge
            badgeContent={notificationRead === 1 ? 0 : notificationCount}
            color="error"
          >
            <NotificationsIcon fontSize="large" />
          </Badge>
        </IconButton>
      </Tooltip>

      {/* Mute Button */}
      <Tooltip title={isMuted ? "Unmute Notifications" : "Mute Notifications"}>
        <IconButton
          onClick={toggleMute}
          sx={{ color: "#1e4b8c", ml: 1 }}
        >
          {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
        </IconButton>
      </Tooltip>

    </Box>
  );
}

const mapStateToProps = ({ liveView }) => ({
  liveView,
});

export default connect(mapStateToProps)(NotificationPanelToggler);
